<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">การคืนสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_add_data" elevation="2" @click="link('/arin/pos/returnproductadd')"
              large>สร้างใบส่งคืนสินค้า</v-btn>
          </div>

        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
          <section class="d-flex justify-space-between">
            <v-row>
              <v-col xs="6" sm="6" md="9" lg="9" xl="9" cols="6" class="content-header-title">
                <!-- <v-tabs color="#D6BFAF" grow>
                    <v-tab @click="page(1)">ประวัติการนับสต๊อก</v-tab>
                    <v-tab @click="page(2)">สร้างรอบนับ</v-tab>
                    <v-tab @click="page(3)">นับสต๊อก</v-tab>
                  </v-tabs> -->
                <div class="">รายการคืนสินค้า</div>

              </v-col>
              <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                <div class="mt-1">
                  <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
                    required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="pa-3">
            <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props"
              mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div class="font-16">{{ dataDetail.item.refund_code }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.created_at }}</div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.product_name }}</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.refund_status == 1" class="font-16">กรุณาส่งสินค้าคืน</div>
                    <div v-if="dataDetail.item.refund_status == 0" class="font-16">รออนุมัติคำร้อง</div>
                    <div v-if="dataDetail.item.refund_status == 2" class="font-16">ได้รับของแล้ว รอดำเนินการแก้ไข</div>
                    <div v-if="dataDetail.item.refund_status == 4" class="font-16">เสร็จสิ้น</div>
                    <div v-if="dataDetail.item.refund_status == 3" class="font-16">คำร้องถูกปฏิเสธ</div>
                  </td>
                  <td>
                    <div class="d-flex">

                      <span>
                        <v-btn elevation="4" class="ma-3 font-16" outlined color="#8EBBDC" title="ดูรายละเอียด"
                          style="border-radius:10px" @click="link('/arin/pos/returnproductdetail?id=' + dataDetail.item.id)">
                          <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                        </v-btn>
                      </span>

                      <!-- @click="edit_count_lot(dataDetail.item.id)" -->

                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </section>


          <!-- Artel แข้งเตือนเสร็จสิ้น -->
          <v-dialog v-model="dialog_cancel_order" persistent max-width="400">
            <v-card class="input-radius">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ยืนยันการปิดรอบนับสต๊อก</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="dialog_cancel_order = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-img width="100" height="100" :lazy-src="img_cancel_order" :src="img_cancel_order"
                      class="preview mt-3 mb-2"></v-img>
                    <h3>คุณต้องการปิดรอบนับสต๊อกหรือไม่</h3>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn type="button" class="btn_add_data_pop" elevation="4" large>ยืนยัน</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
// import cancel_order from "@/assets/checked_refund.png";
// import { minDate } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Admin_list",
  data() {
    return {
      loading_page: true,
      search: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'หมายเลขการคืน',
          value: '',
          fixed: true,
          width: '120px',
        },
        {
          text: 'วันที่ทำเรื่องคืน',
          value: '',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: '',
          fixed: true,
          width: '240px',
        },
        {
          text: 'สถานะ',
          value: 'product_code',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '150px',
        },
      ],
      data_list: [
        {
          id: 1,
          round_count: 'CN08122022005',
          date: '08/12/2022',
          note: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
          created_by: 'กรุณาส่งสินค้าคืน',
        },
        {
          id: 2,
          round_count: 'CN08122022004',
          date: '08/12/2022',
          note: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
          created_by: 'รออนุมัติคำร้อง',
        },
        {
          id: 3,
          round_count: 'CN08122022003',
          date: '08/12/2022',
          note: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
          created_by: 'ได้รับของแล้ว รอดำเนินการแก้ไข',
        },
        {
          id: 4,
          round_count: 'CN08122022002',
          date: '08/12/2022',
          note: 'ยาดม IZE JELLI BALM 7 G 29.-',
          created_by: 'เสร็จสิ้น',
        },
        {
          id: 5,
          round_count: 'CN08122022001',
          date: '08/12/2022',
          note: 'cr.DELANIN CREAM 5G 180.-',
          created_by: 'คำร้องถูกปฏิเสธ',
        },
      ],
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'การคืนสินค้า',
          disabled: false,
          href: '#',
        },
      ],
    }
  },
  methods: {
    link(text){
      this.$router.push(text)
    },
   returnProductList() {
    const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/refund/list', config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
          this.loading_page = false;
        }
      })
  }
  },
 mounted(){
  this.returnProductList()
 }
  // returnProductList() {
  //   const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
  //     HTTP_ARIN.get('/account/book/detail/' + id, config).then((res) => {
  //       if (res.data.successful === true) {
  //         this.loading_page = false;
  //         this.account_main_detail = res.data.obj.accountBook;
  //         this.account_main_detail_log = res.data.obj.accountBookLog;
  //         this.detail_account = true
  //         console.log(this.account_main_detail);
  //       }
  //     })
  // }

}
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */
.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.radio_half {
  display: grid;
  grid-template-columns: 50%;
}

.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-between;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
  display: inline-block;
}

.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.text_header {
  color: #616A6B;
  font-weight: bold;
  font-size: 20px;
}

.text_header_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 22px;
}

/* ขนาด font 16 */
.font-16 {
  font-size: 16px !important;
}


.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.input_two_four {
  display: grid;
  grid-template-columns: 20% 40%;
}

.input_four_six {
  display: grid;
  grid-template-columns: 40% 60%;
}

.content-header-title {
  color: #616A6B;
  font-weight: 1000;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.btn_detail_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #0F71B9 0%, rgba(136, 179, 88, 0) 100%), #8EBBDC !important;
  border-radius: 10px;
  width: 100%;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 100% !important;
}

.btn_add_data_pop {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 135px !important;
}</style>
